export function ClockLight({ width = 16 }: { width?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width={width}
      fill="none"
    >
      <path
        d="M256 16C123.5 16 16 123.5 16 256s107.5 240 240 240 240-107.5 240-240S388.5 16 256 16zm0 448c-114.9 0-208-93.1-208-208S141.1 48 256 48s208 93.1 208 208-93.1 208-208 208zm16-304v137.6l100.3 58.9c7.6 4.5 10.2 14.2 5.7 21.8s-14.2 10.2-21.8 5.7l-112-65.8c-5-2.9-8.2-8.3-8.2-14.2V160c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        fill="currentColor"
      />
    </svg>
  );
}
